/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import "./CnVideo.css";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

class CnVideo extends Component {
  render() {
    return (
      <div className="CnVideo-view">
        <Helmet>
          <title>Video - CheckPlus</title>
        </Helmet>
        <Link to="/Cn">
          <div className="CnVideo-closeBtn" />
        </Link>

        <div className="CnVideo-container">
          <iframe
            className="CnVideo-iframe"
            title="Introducing CheckPlus"
            src="https://www.youtube.com/embed/gqgHB-2wutA"
            frameBorder="0"
            webkitallowfullscreen="webkitallowfullscreen"
            mozallowfullscreen="mozallowfullscreen"
            msallowfullscreen="msallowfullscreen"
            oallowfullscreen="oallowfullscreen"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
      </div>
    );
  }
}

export default CnVideo;
